export default __webpack_public_path__ + "static/media/icon3.f9e7eb16.svg";